import React, { useEffect } from "react";

export default function ExecutiveLeaders({ 
  accent = "#115e32",
  pageTitle = "Executive Leaders | University of Creative Technology Chittagong",
}) {
	useEffect(() => {
		document.title = pageTitle;
	}, [pageTitle]);
  return (
    <div className="relative overflow-hidden">
      {/* ===== Hero Section ===== */}
      <section className="relative bg-gradient-to-b from-[#B7EAFC] via-[#F0FCFF] to-[#F0FCFF] py-20">
        {/* Decorative SVG */}
        <svg
          className="absolute top-0 left-0 w-full h-full opacity-10"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
          viewBox="0 0 800 400"
        >
          <path
            d="M 0 200 Q 200 100 400 200 T 800 200 V 400 H 0 Z"
            fill="#b38a1f"
          />
          <circle cx="700" cy="100" r="80" fill="#1f6da8" opacity="0.4" />
          <circle cx="100" cy="350" r="50" fill="#b38a1f" opacity="0.4" />
        </svg>

        <div className="relative z-10 container mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-extrabold text-[#1f6da8] mb-4 animate-fadeInDown animate-bounce">
            Executive Leaders
          </h1>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto animate-fadeInUp">
            University of Creative Technology, Chittagong (UCTC) – A vision-driven
            institution for innovation, technology, and excellence in higher
            education.
          </p>
        </div>
      </section>
	  <section className="relative py-16 bg-white">
	   </section>
    </div>
  );
}
